import { Rect, Vector2 } from "peet-math";
import { Control } from "./control";
import { ViewPort } from "./viewport";
import { CSSDummyStyle, isPointInsideRect } from "./util";
import { SeatStatusEnum } from "./plan-seat";
import { GestureVenuePlan } from "./gesture-venue-plan";
import { PlanSection } from "./plan-section";


export class SectionControl extends Control {
    public containerTag: JQuery<HTMLElement>;
    public venuePlan: GestureVenuePlan;
    //public planSettings: PlanSettings;

    public section: PlanSection;
    public boundingBox: Rect;
    public style: [CSSDummyStyle, CSSDummyStyle]; // [leftPart, rightPart]
    public cssDummy: any;
    public isClickable: boolean = true;
    public isMouseOver: boolean = false;

    constructor(venuePlan: GestureVenuePlan, section: PlanSection, style: [CSSDummyStyle, CSSDummyStyle]) {
        super()
        this.render = this.render.bind(this);
        this.venuePlan = venuePlan;
        this.section = section;
        this.style = style;
        
        this.containerTag = this.venuePlan.viewPortTag;
        this.boundingBox = new Rect(this.section.position.x, this.section.position.y, 10, 10); // Start with a small rect. The real size will be calculated in the render because we need the size of the text.
        this.refreshState();
    }
    
    public setState(state: SeatStatusEnum) {
        //this.section.state = state;
        this.refreshState();
    }

    public refreshState() {
            
    }

    private getBoundingBox(): Rect {
        return this.boundingBox;
        
    }
    
    public override isPlanPointInside?(point: Vector2): boolean {
        return isPointInsideRect(this.getBoundingBox(), point);
    }

    public override isViewportPointInside?(viewport: ViewPort, point: Vector2): boolean {
        const vpRect = this.getVPBoundingBox(viewport);
        
        const colision = isPointInsideRect(vpRect, point);
        // if(colision) {
        //     console.log("colision detected", this.boundingBox, vpRect, point.x, point.y);
        // }
        return colision
    }

    public override handleMouseIn?(viewport: ViewPort, _point: Vector2) { 
        // console.log("handleMouseIn on section");
        if(this.isClickable) {
            viewport.viewPortTag.css('cursor', 'pointer');
            this.isMouseOver = true;
        }
    }
    public override handleMouseOut?(viewport: ViewPort, _point: Vector2) { 
        // console.log("handleMouse OUT on section");
        if(this.isClickable) {
            viewport.viewPortTag.css('cursor', 'auto');
            this.isMouseOver = false;
        }
    }

    private getVPBoundingBox(viewport: ViewPort): Rect {
        return planRectToVPRect(viewport, this.getBoundingBox());
    }

    render(viewport: ViewPort, canvasCtx: CanvasRenderingContext2D) {
        if (this.visible) {
            // TODO: Do some clean up in that function. Maybe don't calculate to much in plan coordinate. Separate the rendered components...


            //const posOnView = viewport.pointPToV(this.boundingBox.getCenter());
            // If canvas available:
            if (canvasCtx != null) {
                // Style
                const cornerRad = 10;
                const txtPadding = 10;
                const borderColor = this.style[0].borderColor;
                const borderWidth = 2;
                const leftFillColor = this.style[0].backgroundColor;
                const rightFillColor = this.style[1].backgroundColor;
                const opacity = 0.9;
                const opacityHover = 1;

                const leftFont: FontInfo = {
                    size: "18px",
                    family: "Arial",
                    color: this.style[0].color,
                }

                const rightFont: FontInfo = {
                    size: "18px",
                    family: "Arial",
                    color: this.style[1].color,
                }
                

                /*
                const posOnView = viewport.pointPToV(this.boundingBox.getCenter());
                const radius = viewport.scalarPToV(this.boundingBox.width / 2); // div by 2 because it's a radius
                */

                const c = canvasCtx;
                const positionP = new Vector2(this.section.position.x, this.section.position.y);
                const showQty = this.section.remainingSeats > 0;
                //const position = new Vector2(this.section.position.x, this.section.position.y);
                
                const sectionName = this.section.name;
                const qty = this.section.remainingSeats.toString();

                // Text
                const nameTextSizeP = measureText(sectionName, leftFont, c);
                const nameWidthP = nameTextSizeP.width;
                const qtyTextSizeP = measureText(qty, rightFont, c);
                const qtyWidthP = qtyTextSizeP.width;

                const textHeightP = nameTextSizeP.actualBoundingBoxAscent;
                const textWidthP = nameWidthP + (showQty ? 2*txtPadding + qtyWidthP : 0);

                const leftSideWidthP = nameWidthP + 2*txtPadding;
                const rightSideWidthP = showQty ? qtyWidthP + 2*txtPadding : 0;

                const buttonWidthP = textWidthP + 2*txtPadding;
                const buttonHeightP = textHeightP + 2*txtPadding;
                
                const rectP = new Rect(positionP.x, positionP.y, buttonWidthP, buttonHeightP);

                // Update this here because we need the text size to do it. It is not in Viewport coordinate but in plan coordinate.
                this.boundingBox = new Rect(this.section.position.x, this.section.position.y, buttonWidthP, buttonHeightP);

                // Convert to viewport coordinate
                const position = viewport.pointPToV(positionP);
                const buttonHeight = viewport.scalarPToV(buttonHeightP);
                const leftSideWidth = viewport.scalarPToV(leftSideWidthP);
                const rightSideWidth = viewport.scalarPToV(rightSideWidthP);
                const textHeight = viewport.scalarPToV(textHeightP);
                const cornerRadVP = viewport.scalarPToV(cornerRad);
                const nameWidth = viewport.scalarPToV(nameWidthP);
                const qtyWidth = viewport.scalarPToV(qtyWidthP);

                const rect = planRectToVPRect(viewport, rectP);
                const namePos = {x: leftSideWidth/2 - nameWidth/2 + position.x, y: buttonHeight/2 + textHeight/2 + position.y } // Calcul la baseline!
                const qtyPos = {x: rightSideWidth/2 - qtyWidth/2 + position.x + leftSideWidth, y: buttonHeight/2 + textHeight/2 + position.y } // Calcul la baseline!

                

                // Caculate each point of the rounded rectangle separated in two parts by pJoint points (Left/Right)
                /*
                     p1        jt   p2
                    /-----------o-----\
                  p8|           |     | p3
                  p7|           |     | p4
                    \-----------o-----/
                     p6        jb   p5
                */

                const srcP1 = rect.getP1();
                const srcP2 = rect.getP2();
                const roundRect = {
                    p1: {x: srcP1.x + cornerRadVP, y: srcP1.y}, // Top Line, left
                    pJointTop: {x: srcP1.x + leftSideWidth, y: srcP1.y}, // Top joint point
                    p2: {x: srcP2.x - cornerRadVP, y: srcP1.y}, // Top Line, right
                    p3: {x: srcP2.x, y: srcP1.y + cornerRadVP}, // Right Line, Top
                    p4: {x: srcP2.x, y: srcP2.y - cornerRadVP}, // Right Line, bottom
                    p5: {x: srcP2.x - cornerRadVP, y: srcP2.y}, // Bottom line, right
                    pJointBottom: {x: srcP1.x + leftSideWidth, y: srcP2.y}, // Bottom joint point
                    p6: {x: srcP1.x + cornerRadVP, y: srcP2.y}, // Bottom line, left
                    p7: {x: srcP1.x, y: srcP2.y - cornerRadVP}, // Left line, bottom
                    p8: {x: srcP1.x, y: srcP1.y + cornerRadVP}, // Left line, top
                    arc1Center: {x: 0, y: 0}, // Top Left
                    arc2Center: {x: 0, y: 0}, // Top Right
                    arc3Center: {x: 0, y: 0}, // Bottom Right
                    arc4Center: {x: 0, y: 0}, // Bottom Left
                };
                roundRect.arc1Center = {x: roundRect.p1.x, y: roundRect.p8.y }; // Top left corner
                roundRect.arc2Center = {x: roundRect.p2.x, y: roundRect.p8.y }; // Top right corner
                roundRect.arc3Center = {x: roundRect.p2.x, y: roundRect.p7.y }; // Bottom right corner
                roundRect.arc4Center = {x: roundRect.p1.x, y: roundRect.p7.y }; // Bottom left corner

                // Left/Full Box
                c.globalAlpha = this.isMouseOver ? opacityHover : opacity;
                c.beginPath();
                if(!showQty) {
                    // Draw full rounded rectangle
                    c.moveTo(roundRect.p1.x, roundRect.p1.y);
                    c.lineTo(roundRect.p2.x, roundRect.p2.y);
                    c.arc(roundRect.arc2Center.x, roundRect.arc2Center.y, cornerRadVP, -Math.PI * 0.5, 0, false);
                    c.lineTo(roundRect.p4.x, roundRect.p4.y);
                    c.arc(roundRect.arc3Center.x, roundRect.arc3Center.y, cornerRadVP, 0, Math.PI * 0.5, false);
                    c.lineTo(roundRect.p6.x, roundRect.p6.y);
                    c.arc(roundRect.arc4Center.x, roundRect.arc4Center.y, cornerRadVP, Math.PI * 0.5, Math.PI * 1, false);
                    c.lineTo(roundRect.p8.x, roundRect.p8.y);
                    c.arc(roundRect.arc1Center.x, roundRect.arc1Center.y, cornerRadVP, Math.PI * 1, -Math.PI * 0.5, false);
                } else {
                    // Draw half rectangle
                    c.moveTo(roundRect.pJointBottom.x, roundRect.pJointBottom.y);
                    c.lineTo(roundRect.p6.x, roundRect.p6.y);
                    c.arc(roundRect.arc4Center.x, roundRect.arc4Center.y, cornerRadVP, Math.PI * 0.5, Math.PI * 1, false);
                    c.lineTo(roundRect.p8.x, roundRect.p8.y);
                    c.arc(roundRect.arc1Center.x, roundRect.arc1Center.y, cornerRadVP, Math.PI * 1, -Math.PI * 0.5, false);
                    c.lineTo(roundRect.pJointTop.x, roundRect.pJointTop.y);
                }

                c.fillStyle = leftFillColor;
                c.fill();
                c.lineWidth = borderWidth;
                c.strokeStyle = borderColor;
                c.stroke();

                // Right Box
                if(showQty) {
                    c.beginPath();
                    c.moveTo(roundRect.pJointTop.x, roundRect.pJointTop.y);
                    c.lineTo(roundRect.p2.x, roundRect.p2.y);
                    c.arc(roundRect.arc2Center.x, roundRect.arc2Center.y, cornerRadVP, -Math.PI * 0.5, 0, false);
                    c.lineTo(roundRect.p4.x, roundRect.p4.y);
                    c.arc(roundRect.arc3Center.x, roundRect.arc3Center.y, cornerRadVP, 0, Math.PI * 0.5, false);
                    c.lineTo(roundRect.pJointBottom.x, roundRect.pJointBottom.y);

                    c.fillStyle = rightFillColor;
                    c.fill();
                    c.lineWidth = borderWidth;
                    c.strokeStyle = borderColor;
                    c.stroke();
                }

                // Name Text
                c.scale(viewport.zoom, viewport.zoom);
                c.font = leftFont.size + " " + leftFont.family;
                c.fillStyle = leftFont.color;
                c.fillText(sectionName, viewport.scalarVToP(namePos.x), viewport.scalarVToP(namePos.y)); 

                
                // Qty Text
                if(showQty) {
                    c.font = rightFont.size + " " + rightFont.family;
                    c.fillStyle = rightFont.color;
                    //c.fillText(qty, qtyPos.x, qtyPos.y);
                    c.fillText(qty, viewport.scalarVToP(qtyPos.x), viewport.scalarVToP(qtyPos.y)); 
                }

                c.setTransform(1, 0, 0, 1, 0, 0); // Reset transform matrix to identity
            }
        }
    }
}

function measureText(txt:string, font: FontInfo, c: CanvasRenderingContext2D): TextMetrics {
    c.font = `${font.size} ${font.family}`;
    return c.measureText(txt);
}

type FontInfo = {
    size: string,
    family: string,
    color: string,
}

function planRectToVPRect(viewport: ViewPort, planRect: Rect): Rect {
    const pos = viewport.pointPToV(planRect.getP1());
    return new Rect(pos.x, pos.y, viewport.scalarPToV(planRect.width), viewport.scalarPToV(planRect.height));
}